<template>
    <div class="aside-scrollable courses" :class="accordionClasses">
        <div class="aside-menu__title" @click="toggleAccordion">
            {{ $t('channels') }}
            <span class="aside-menu__arrow-box"></span>
        </div>

        <vue-custom-scrollbar class="accordion scroll-area">
            <ul id="main-menu" class="aside-menu">

                <li :key="accKey" v-if="isChannelWithCategory">
                    <div class="aside-menu--sub"
                         v-for="category in categoryCourses"
                         :key="category.id"
                         :class="{'is-closed': !category.isOpen, 'is-primary': category.isOpen}"
                    >
                        <div class="aside-menu__title aside-menu__title--sub"
                             v-if="category && category.courses && category.courses.length"
                             @click="toggleAccordionInner(category)"
                        >
                            {{category.name}}
                            <span class="aside-menu__arrow-box aside-menu__arrow-box--sub"></span>
                        </div>

                        <div class="accordion--sub">
                            <app-left-panel-course
                                v-for="course in category.courses"
                                :course="course"
                                :key="course.id"
                            ></app-left-panel-course>
                        </div>
                    </div>
                </li>

                <app-left-panel-course
                    v-for="course in noCategoryCourses"
                    :course="course"
                    :key="course.id"
                ></app-left-panel-course>
            </ul>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanelCourse from './LeftPanelCourse.vue';
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import env from '../../env';
    import helpers from '../../helpers'

    export default {
        data: () => ({
            env,
            isOpen: true,
            categoryList: [],
            accKey: Math.random(),
        }),
        components: {
            appLeftPanelCourse: LeftPanelCourse,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        methods: {
            toggleAccordion() {
                this.isOpen = !this.isOpen;
            },
            toggleAccordionInner(category) {
                category.isOpen = !category.isOpen;
                this.accKey++;
                this.$store.commit('SET_COURSES', this.courses);
            },
        },
        computed: {
            ...mapGetters([
                'courses',
                'userData',
                'channelCategories',
            ]),
            isChannelWithCategory() {
                return this.courses && !!this.courses.filter(course => course.category).length
            },
            filteredCourses() {
                if (this.courses !== null && this.userData !== null) {
                    return this.courses.filter(item => item.is_group || item.is_tech)
                } else {
                    return this.courses
                }
            },
            categoryCourses() {
                let res = [];
                if(this.filteredCourses) {
                    this.channelCategories.forEach(category => {
                        this.filteredCourses.forEach(course => {
                            if(category.id === course.category) {
                                if(!category.courses) category.courses = [];
                                category.isOpen ? category.isOpen = true : category.isOpen = false;
                                category.courses.push(course);
                                category.courses = helpers.getUnique(category.courses, 'id')
                            }
                        });
                        res.push(category)
                    });
                }
                return res;
            },
            noCategoryCourses() {
                return this.filteredCourses && this.filteredCourses.filter(course => !course.category);
            },
            accordionClasses() {
                return {
                    'is-closed': !this.isOpen,
                    'is-primary': this.isOpen
                };
            },
        },
    }
</script>

<style scoped>
    .scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: 100%;
        max-height: 290px;
    }
</style>
